/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportIncidentService } from '../services/reportincident.service';
import { IncidentFileUpload, RequestResponse, CustomFieldRequest } from '../model/reportincident.response';
import { CustomField } from '../../../shared/model/customfieldsresponse';
import { AlertMessage } from '../../../../../shared/alert/alertmessage';
import { AlertService } from '../../../../../shared/alert/alert.service';
import { RequestService } from '../services/requestservice';
import { CustomerPreferenceService } from '../../../../preference/customerpreference.service';
import { CustomerPreferenceResponse } from '../../../../preference/customerpreference.model';
import { UIMessageService } from '../../../shared/services/uimessages.service';
import { UIMessagesResponse } from '../../../shared/model/uimessagesresponse';
import { DomSanitizer } from '@angular/platform-browser';
import { SpinnerService } from '../../../../../shared/spinner/spinner.service';
import { Subscription, Observable } from 'rxjs';
import { CommonConstants } from '../../../../../common/constants/common-constants';
import { CreatedRequestResponse } from '../model/createdrequestresponse';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ZSDTranslateService } from '../../../../../common/zsd-translate.service';
import { FileUploadStatus } from '../../../store/model/fileuploadstatus';
import { ClientInfo, CustomerSearchInfoResponse } from '../../../requests/model/clientinfo';
import { RequestDetailService } from '../../../requests/services/request-detail.service';
import { RequestlistSearchService } from '../../../requests/services/requestlist-searchservice';
import { RequestDetailResponse, CustomFormField } from '../../../requests/model/requestdetailresponse';
import { RequestNotes } from '../../../requests/model/requestnotesresponse';
import { RequestInfo } from '../../../requests/model/requestinforesponse';
import { RequestCustomFieldInfo } from '../../../requests/model/requestcustomfieldinforesponse';
import { RequestslistService } from '../../../requests/services/requestslist.service';
import { debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'zsd-reportincident',
  templateUrl: '../view/reportincident.component.html',
  styleUrls: ['../view/reportincident.component.scss']
})
export class ReportIncidentComponent implements OnInit, OnDestroy {
  @Input() index: number;

  ccList: ClientInfo[] = new Array();
  ccField = new FormControl();
  currentCcUserIndex = -1;
  ccUserSearchResultCount = 0;
  requestDetailResponse: RequestDetailResponse = new RequestDetailResponse();
  requestNotesResponse = new Array<RequestNotes>();
  requestInfo: RequestInfo = new RequestInfo();
  requestCustomfield = new Array<RequestCustomFieldInfo>();
  customFormField = new Array<CustomFormField>();
  maxLength = 350;
  currentText: string;
  public isCollapsed = true;
  matrix = [];
  usersLoading = false;
  users: Observable<CustomerSearchInfoResponse>;

  incidentRequest: RequestResponse = new RequestResponse();
  createdRequestResponse: CreatedRequestResponse = new CreatedRequestResponse();
  reportIncidentForm: FormGroup;
  storeItemId: number;
  serverError = null;
  showSubject = false;
  itemTypeIdForSelectedItem = null;
  subjectRequired = false;
  subjectFieldFocus = false;
  incidentSubject = '';
  requestDescription = '';
  canCreateIncidentValue: boolean;
  customFields: (CustomField)[] | null;
  incidentFileUpload: IncidentFileUpload = new IncidentFileUpload();
  fileUploadForm: boolean;
  public validFileList: Array<File> = [];
  uiMessageListResults: Array<UIMessagesResponse> = [];
  incidentLegend;
  itemSelectionRequired;
  itemSelectionFormValid: boolean;
  showAdditionalInfo;
  showNotifyField;
  loading = false;
  itemSelectionSubscription: Subscription;
  @Input() fromNewRequestPage;

  @Output() private clearForm: EventEmitter<boolean> = new EventEmitter();
  processIndex;
  processIndexString;
  itemIdNumber;
  fromItem = false;
  fromService = false;
  userSearchCurrentDisplayedCount: number;
  userSearchOffset: number;
  userSearchLimit: number;
  userSearchTerm: string;
  userSearchInfo: CustomerSearchInfoResponse;
  // itemId;

  private _itemId: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  private _customCategory: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  @Input() set customCategory(value: string) {
    this._customCategory.next(value);
  }

  @Input() set itemId(value: number) {
    this._itemId.next(value);
  }

  get itemId() {
    return this._itemId.getValue();
  }

  get customCategory() {
    return this._customCategory.getValue();
  }
  constructor(public formBuilder: FormBuilder, public router: Router, public alertService: AlertService,
    public route: ActivatedRoute, public reportIncidentService: ReportIncidentService, public incidentService: RequestService,
    public customerPreferenceService: CustomerPreferenceService, public uiMessageService: UIMessageService,
    public _DomSanitizer: DomSanitizer, public spinnerService: SpinnerService, public zsdTranslate: ZSDTranslateService,
    public requestDetailService: RequestDetailService, public requestListSearchService: RequestlistSearchService,
    public requestListService: RequestslistService) {
  }


  ngOnInit() {
    // this.users = this.ccField.valueChanges.pipe( debounceTime(400), distinctUntilChanged(),
    // tap(() => this.usersLoading = true),
    // switchMap(searchTerm => this.requestDetailService.findUser(searchTerm)),
    // tap(() => this.usersLoading = false)
    // ).do(resp => {
    //     this.ccUserSearchResultCount = resp.length;
    //   }
    //   );

      this.users = this.ccField.valueChanges.pipe(
        debounceTime(400),
        distinctUntilChanged(),
        // filter((searchTerm) => (searchTerm.length > 1)),
        tap(() => this.usersLoading = true),
        switchMap(searchTerm => {
          this.userSearchTerm = searchTerm;
          return this.requestDetailService.findUser(searchTerm , 0 , 10);
        }),
        tap((resp) => {
          // if (resp) {
          //   this.searchListFlag = true;
          // }
          this.usersLoading = false;
          this.userSearchOffset = 0;
          this.userSearchLimit = 10;
          this.ccUserSearchResultCount = resp.resultCount;
          this.userSearchCurrentDisplayedCount = resp.results.length;
        })
      );

      this.users.forEach((info) => {
        this.userSearchInfo = info;
      });


    this.router.events.subscribe(
      () => {
        if (this.router.url.includes('item')) {
          this.fromItem = true;
        }
        if (this.router.url.includes('sitem')) {
          this.fromService = true;
        }
      });

    this._customCategory.subscribe(() => {
      this.processIndexString = this.customCategory;
    });
    this._itemId.subscribe(() => {
      this.itemIdNumber = this.itemId;
    });


    this.processIndex = this.processIndexString.toUpperCase();
    this.reportIncidentForm = this.formBuilder.group({
      incidentSubject: this.formBuilder.control({ value: '' })
    });
    // subject
    this.customerPreferenceService.getPreferenceList().subscribe(
      (preferences: CustomerPreferenceResponse) => {
        this.showSubject = preferences.showSubject;
        this.subjectRequired = preferences.subjectRequired;
        this.itemSelectionRequired = preferences.itemSelectionRequired;
        this.showAdditionalInfo = preferences.showAdditionalInfo;
        this.showNotifyField = preferences.showNotify;
        if (this.subjectRequired) {
          this.reportIncidentForm.get('incidentSubject').setValidators(Validators.required);
        }
        this.reportIncidentForm.get('incidentSubject').setValue(this.incidentSubject);
      },
      err => console.error(err)
    );

    this.uiMessageService.getUIMessagesList().subscribe(
      (uimessages: UIMessagesResponse[]) => {
        this.uiMessageListResults = uimessages;
        for (let i = 0; i < this.uiMessageListResults.length; i++) {
          if (this.uiMessageListResults[i].name === 'IncidentLegend') {
            this.incidentLegend = this.uiMessageListResults[i].content;
          }
        }
      },
      err => console.error(err)
    );

    // global custom fields
    this.reportIncidentService.getCustomFields(null, this.processIndexString).subscribe(
      (customFieldResponse: CustomField[]) => {
        this.customFields = customFieldResponse;
      },
      err => console.error(err)
    );

    this.loadCustomFieldOnItemSelection();
  }

  ngOnDestroy() {
    if (this.itemSelectionSubscription) {
      this.itemSelectionSubscription.unsubscribe();
    }
  }

  loadCustomFieldOnItemSelection() {
    this.itemSelectionSubscription = this.incidentService.getItemSelection().subscribe((typeId: number) => {
      this.reportIncidentService.getCustomFields(typeId, this.processIndexString).subscribe(
        (customFieldResponse: CustomField[]) => {
          this.customFields = customFieldResponse;
        },
        err => console.error(err)
      );
    });
  }

  isfileuploadformvalid(formvalid: boolean) {
    this.fileUploadForm = formvalid;
  }

  isItemSelectionformvalid(formvalid: boolean) {
    this.itemSelectionFormValid = formvalid;
  }

  selectedFilesList(fileList: Array<File>) {
    const newFileList = [];
    for (let i = 0; i < fileList.length; i++) {
      newFileList.push(fileList[i]);
    }
    this.validFileList = newFileList;
  }

  subjectEmpty() {
    return this.reportIncidentForm.get('incidentSubject').value === '';
  }

  createRequest() {
    this.loading = true;
    this.spinnerService.show();
    this.incidentRequest = new RequestResponse();
    this.serverError = null;
    this.incidentRequest.requestProcessIndex = this.processIndex;
    if (this.reportIncidentForm.valid && this.fileUploadForm && ( this.itemSelectionFormValid || this.itemSelectionRequired === 2)) {
      if (this.reportIncidentForm.value.itemSelection.item.value === -1
        || this.reportIncidentForm.value.itemSelection.item === -1
        || this.reportIncidentForm.value.itemSelection.item.value === null
        || this.itemSelectionRequired === 2) {
        this.incidentRequest.itemId = null;
      } else {
        this.incidentRequest.itemId = this.reportIncidentForm.value.itemSelection.item;
        this.incidentRequest.classfication = ((this.reportIncidentForm.controls['itemSelection'] as FormGroup).
        controls['classification'].value);
        this.incidentRequest.urgencyTypeId = ((this.reportIncidentForm.controls['itemSelection'] as FormGroup).
        controls['urgency'].value);
        this.incidentRequest.priorityTypeId = ((this.reportIncidentForm.controls['itemSelection'] as FormGroup).
        controls['priority'].value);
      }
      this.incidentRequest.subject = this.incidentSubject;
      this.incidentRequest.requestDescription = this.reportIncidentForm.value.tinyMce.tinymce;

     // Adding Conditional Check as Additional Info is now based on privileges
      if (this.showAdditionalInfo) {
        this.incidentRequest.contactEmail = this.reportIncidentForm.value.contactInfo.email;
        this.incidentRequest.contactPhone = this.reportIncidentForm.value.contactInfo.phone;
        this.incidentRequest.location = this.reportIncidentForm.value.additionalInfo.location;
        this.incidentRequest.contactType = parseInt(this.reportIncidentForm.value.contactInfo.contactType, 10);
        this.incidentRequest.contactTime = parseInt(this.reportIncidentForm.value.contactInfo.contactTime, 10);
        this.incidentRequest.contactTimePeriod = parseInt(this.reportIncidentForm.value.contactInfo.contactTimeTt, 10);
      }

      if (this.incidentRequest.contactType === 0) {
        this.incidentRequest.contactEmail = null;
        this.incidentRequest.contactPhone = null;
        this.incidentRequest.contactTime = null;
        this.incidentRequest.contactTimePeriod = null;
      }
      if (this.incidentRequest.contactType === 1) {
        this.incidentRequest.contactPhone = null;
        this.incidentRequest.contactTime = null;
        this.incidentRequest.contactTimePeriod = null;
      }

      if (this.incidentRequest.contactType === 2) {
        this.incidentRequest.contactEmail = null;
      }

      for (let i = 0; i < this.customFields.length; i++) {
        let customField: CustomField = this.customFields[i];
        if (!this.incidentRequest.customFields) {
          this.incidentRequest.customFields = new Array<CustomFieldRequest>();
        }
        if (customField.clientEditable !== 0) {
          let customfieldRequest: CustomFieldRequest = new CustomFieldRequest();
          customfieldRequest.fieldId = customField.fieldId;
          if (customField.dataType === 4) { // Currency
            customfieldRequest.fieldValue = this.getActualCurrencyValue(this.reportIncidentForm.value[customField.fieldId].data);
          } else {
            customfieldRequest.fieldValue = this.reportIncidentForm.value[customField.fieldId].data;
          }
          this.incidentRequest.customFields.push(customfieldRequest);
        }
      }

      if (this.ccList) {
        let ccListEmail = this.ccList.map(userInfo => userInfo.email);
        this.incidentRequest.customerCC = ccListEmail.join(','); // Make a string of all emails seperated by comma.
      }

      // creating Request

      this.reportIncidentService.createRequest(this.incidentRequest).subscribe(
        (createdRequestResponse: CreatedRequestResponse) => {
          this.createdRequestResponse = createdRequestResponse;
          const alertMessage = new AlertMessage();
          alertMessage.type = 'info';
          alertMessage.message = 'Alert.requestCreated';
          // Hiding the Form, Changing the Modal Size and Displaying the Success Message content inside the same modal
          // This can be enhanced later

          alertMessage.params = this.createdRequestResponse.requestId.toString();
          this.incidentFileUpload.files = this.validFileList;
          this.incidentFileUpload.requestId = this.createdRequestResponse.requestId;
          if (this.validFileList.length > 0) {
            this.reportIncidentService.uploadAttachments(this.incidentFileUpload).subscribe(
              (fileUploadStatus: FileUploadStatus) => {
                this.loading = false;
                if (fileUploadStatus.failureFiles && fileUploadStatus.failureFiles.length > 0) {
                  alertMessage.status = this.zsdTranslate.getTranslatedString('Alert', 'fileUploadfailure');
                  alertMessage.status += (fileUploadStatus.failureFiles.join(','));
                }
                this.alertService.displayAlert(alertMessage);
                // this.router.navigate([CommonConstants.STORE_COMPONENT]);
                this.updateModalAfterRequestCreation();
              },
              err => {
                this.loading = false;
                if (err.error.localizedMessage) {
                  alertMessage.status = err.error.localizedMessage;
                } else {
                  alertMessage.status = err.error.message;
                }
                this.alertService.displayAlert(alertMessage);
                // this.router.navigate([CommonConstants.STORE_COMPONENT]);
                this.updateModalAfterRequestCreation();
              });
          } else {
            this.loading = false;
            this.alertService.displayAlert(alertMessage);
            // this.router.navigate([CommonConstants.STORE_COMPONENT]);
            this.updateModalAfterRequestCreation();
          }
        },
        err => {
          this.loading = false;
          this.serverError = 'Unable to connect to the server.';
          if (err.error.localizedMessage) {
            this.serverError = err.error.localizedMessage;
          } else if (err.error.message) {
            this.serverError = err.error.message;
          }
        }
      );
    } else {
      this.loading = false;
      (this.reportIncidentForm.controls['tinyMce'] as FormGroup).controls['tinymce'].markAsTouched();
      if (this.showAdditionalInfo) {
      (this.reportIncidentForm.controls['contactInfo'] as FormGroup).controls['email'].markAsTouched();
      (this.reportIncidentForm.controls['contactInfo'] as FormGroup).controls['phone'].markAsTouched();
      }
      if (this.itemSelectionRequired === 1) {
        (this.reportIncidentForm.controls['itemSelection'] as FormGroup).controls['item'].markAsTouched();
        (this.reportIncidentForm.controls['itemSelection'] as FormGroup).controls['category'].markAsTouched();
        (this.reportIncidentForm.controls['itemSelection'] as FormGroup).controls['itemType'].markAsTouched();
      }
      if (this.showSubject) {
        this.reportIncidentForm.controls['incidentSubject'].markAsTouched();
      }
      for (let i = 0; i < this.customFields.length; i++) {
        let fieldId = this.customFields[i].fieldId + '';
        (this.reportIncidentForm.controls[fieldId] as FormGroup).controls['data'].markAsTouched();
      }
    }
  }

  updateModalAfterRequestCreation() {
    $('#report_incident_row').hide();
    if ($(window).width() < 991) {
      $('#zsd_modal_new_request').css('width', '80%');
      $('#zsd_modal_new_request').css('margin-left', '8%');
    } else {
      $('#zsd_modal_new_request').css('width', '40%');
      $('#zsd_modal_new_request').css('margin-left', '30%');
    }


    $('#zsd_modal_new_request .modal-header').css('display', 'none');
    $('#zsd_modal_new_request .modal-header').hide();
    $('#request_success_msg').show();
 }

  getActualCurrencyValue(formattedCurrencyValue) {
    if (formattedCurrencyValue) {
      formattedCurrencyValue = formattedCurrencyValue.replace(/[^\d\.\-eE+]/g, '');
      formattedCurrencyValue = formattedCurrencyValue ? parseFloat(formattedCurrencyValue) : 0;
      formattedCurrencyValue = !formattedCurrencyValue ? 0 : formattedCurrencyValue;
    }
    return formattedCurrencyValue;
  }

  cancelRequest() {
    this.clearForm.emit(true);

    if (this.fromNewRequestPage) {
      this.router.navigate([CommonConstants.NEWREQUEST_COMPONENT]);
    }
    if (this.fromItem) {
      this.router.navigate([CommonConstants.ITEMS_COMPONENT, this.itemId]);
    }
    if (this.fromService) {
      this.router.navigate([CommonConstants.SERVICES_COMPONENT, this.itemId]);
    }
    $('#zsd_modal_new_request').modal('hide');
  }

  showProposedSolutionPage(requestId: number): string {
    return '/proposedsolution/' + requestId;
  }

  setFocusToCCField() {
    document.getElementById('input-user' + this.index).focus();
  }

  addToCCList(selectedUser: ClientInfo) {
    this.ccList.push(selectedUser);
    this.ccField.setValue(null);
    document.getElementById('input-user' + this.index).focus();

    this.currentCcUserIndex = -1;
  }

  removeFromCCList(indexToRemove: number) {
    this.ccList.splice(indexToRemove, 1);
    document.getElementById('input-user' + this.index).focus();
  }

  ccListKeyPressAction(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;

    // Backspace action, remove last user
    if (charCode === 8 && !this.ccField.value && this.ccList.length > 0) {
      this.ccList.splice(this.ccList.length - 1, 1);
      document.getElementById('input-user' + this.index).focus();
      this.currentCcUserIndex = -1;
    } else if (charCode === 40) { // Key Down action
      event.preventDefault();
      this.currentCcUserIndex++;
      if (this.currentCcUserIndex >= this.userSearchCurrentDisplayedCount) {
        this.currentCcUserIndex = 0;
      }
      let listid = `user${this.currentCcUserIndex}`;
      let elmnt = document.getElementById(listid);
      elmnt.scrollIntoView(false);
      window.scrollTo(0, 0);
    } else if (charCode === 38) { // Key up action
      event.preventDefault();
      this.currentCcUserIndex--;
      if (this.currentCcUserIndex < 0) {
        this.currentCcUserIndex = (this.userSearchCurrentDisplayedCount - 1);
      }
      let listid = `user${this.currentCcUserIndex}`;
      let elmnt = document.getElementById(listid);
      elmnt.scrollIntoView(false);
      window.scrollTo(0, 0);
    } else if (charCode === 13) { // Enter action
      event.preventDefault();
      document.getElementById('user' + this.currentCcUserIndex).click();
    } else {
      this.currentCcUserIndex = -1;
    }

    return true;
  }

  getRequestDetails(requestNumber) {
    this.requestDetailService.getRequestDetail(requestNumber)
      .subscribe((reqDetailResponse: RequestDetailResponse) => {
        this.requestDetailResponse = reqDetailResponse;
        this.requestNotesResponse = reqDetailResponse.requestNotes;
        this.requestInfo = reqDetailResponse.requestInfo;
        this.requestCustomfield = reqDetailResponse.requestCustomFieldInfo;
        this.ccList = this.requestInfo.ccList;
        this.customFormField = reqDetailResponse.customFormFields;
        if (this.validateSource(this.requestInfo.description)) {
          setTimeout(() => {
            this.determineView();
          }, 1);
        }
        if (this.customFormField.length > 0) {
          this.setDataForCustomformFields();
        }
      });
}

validateSource(s) {
  if (typeof s !== 'string') {
    return false;
  } else {
    return true;
  }
}

determineView() {
  if (this.requestInfo.description.length <= this.maxLength) {
    this.currentText = this.requestInfo.description;
    this.isCollapsed = false;
    return;
  }

  if (this.isCollapsed === true) {
    this.currentText = this.requestInfo.description.substring(0, this.maxLength) + ' ...';
  } else if (this.isCollapsed === false) {
    this.currentText = this.requestInfo.description;
  }
}

setDataForCustomformFields() {
  let chunkSize = 2;
  let arr = this.customFormField;
  let groups = arr.map(function (e, i) {
    return i % chunkSize === 0 ? arr.slice(i, i + chunkSize) : null;
    console.log(e);
  });
  this.matrix = groups;
}

getRequestDetailsAfterUpdate(requestNumber) {
  this.requestDetailService.getRequestDetail(requestNumber)
    .subscribe((reqDetailResponse: RequestDetailResponse) => {
      this.requestDetailResponse = reqDetailResponse;
        this.requestNotesResponse = reqDetailResponse.requestNotes;
        this.requestInfo = reqDetailResponse.requestInfo;
        this.requestCustomfield = reqDetailResponse.requestCustomFieldInfo;
        this.ccList = this.requestInfo.ccList;
        this.requestListService.publishRequestChanges(this.requestInfo);
      if (this.validateSource(this.requestInfo.description)) {
        setTimeout(() => {
          this.determineView();
        }, 1);
      }
    });
}

public getUserDisplayString(user: ClientInfo): string {
  if (user.fullName) {
      return user.fullName + '<' + user.email + '>';
  }

  return user.email;
}

scrollEndForCustomerSearch() {
  let s = $('#reportincident-search-list').prop('scrollHeight');
  let s1 = $('#reportincident-search-list').scrollTop() + $('#reportincident-search-list').height();
  if ((s / 2) < s1) {
    if ( this.userSearchCurrentDisplayedCount < this.ccUserSearchResultCount) {
      this.usersLoading = true;
      this.userSearchOffset = this.userSearchOffset + 1;
      this.userSearchLimit = 10;
      this.userSearchCurrentDisplayedCount = this.ccUserSearchResultCount;
      this.requestDetailService.findUser(this.userSearchTerm, this.userSearchOffset, this.userSearchLimit)
      .pipe(debounceTime(400)
        , distinctUntilChanged()
        ).subscribe((resp) => {
          this.usersLoading = false;
          this.ccUserSearchResultCount = resp.resultCount;
          let temp = this.userSearchInfo.results;
          temp = temp.concat(resp.results);
          this.userSearchInfo = resp;
          this.userSearchInfo.results = temp;
          this.userSearchCurrentDisplayedCount = this.userSearchInfo.results.length;
        });
     }
  }
}
}
